// import React from 'react';
// import moment from 'moment';
// import IconComponent from '../../PackageItinerary/components/IconComponent'; // Adjust the path as needed

// const InfoRoute = ({ headerText, captionText, pickupLocation, dropLocation, pickupTime, dropTime, totalDistance }) => {
//   const pickupTimeFormatted = pickupTime ? moment(pickupTime).format('h:mm A') : '';
//   const dropTimeFormatted = dropTime ? moment(dropTime).format('h:mm A') : '';

//   return (
//     <div className="w-full mx-auto p-4 rounded-lg shadow-md">
//       <div className="flex justify-between">
//         <h2 className="text-lg font-bold">Pickup</h2>
//       </div>

//       <div className="mt-4">
//         {pickupLocation && pickupLocation.latitude && pickupLocation.longitude &&
//           <div>
//             <button
//               className="flex items-center space-x-2 text-black"
//               onClick={() => window.open(`google.navigation:q=${pickupLocation.latitude},${pickupLocation.longitude}&mode=d`)}
//             >
//               <IconComponent
//                 iconSet="MaterialCommunityIcons"
//                 iconName="map-marker"
//                 iconSize={20}
//                 className="text-black"
//               />
//               <span className="text-sm">Open in Maps</span>
//             </button>

//             <div className="mt-2">
//               {pickupLocation.title &&
//                 <p className="text-base font-medium">{pickupLocation.title}</p>
//               }
//               {pickupLocation.subText &&
//                 <p className="text-sm">{pickupLocation.subText}</p>
//               }
//             </div>
//           </div>
//         }
//       </div>


//     </div>
//   );
// }

// export default InfoRoute;


import React from 'react';
import moment from 'moment';
import IconComponent from '../../PackageItinerary/components/IconComponent'; // Adjust the path as needed

const InfoRoute = ({ pickupLocation, dropLocation, pickupTime, dropTime }) => {
  const pickupTimeFormatted = pickupTime ? moment(pickupTime).format('h:mm A') : '';
  const dropTimeFormatted = dropTime ? moment(dropTime).format('h:mm A') : '';

  return (
    <div className="w-full mx-auto p-4 rounded-lg shadow-md">
      <div className="flex flex-col md:flex-row justify-between gap-6">
        {/* Pickup Section */}
        <div className="w-full md:w-1/2">
          <h2 className="text-lg font-bold">Pickup</h2>
          <div className="mt-4">
            {pickupLocation?.latitude && pickupLocation?.longitude && (
              <div>
                <button
                  className="flex items-center space-x-2 text-black"
                  onClick={() =>
                    window.open(`google.navigation:q=${pickupLocation.latitude},${pickupLocation.longitude}&mode=d`)
                  }
                >
                  <IconComponent
                    iconSet="MaterialCommunityIcons"
                    iconName="map-marker"
                    iconSize={20}
                    className="text-black"
                  />
                  <span className="text-sm">Open in Maps</span>
                </button>

                <div className="mt-2">
                  {pickupLocation.title && <p className="text-base font-medium">{pickupLocation.title}</p>}
                  {pickupLocation.subText && <p className="text-sm">{pickupLocation.subText}</p>}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="my-4 h-px bg-gray-200" />
        {/* Drop Section */}
        <div className="w-full md:w-1/2">
          <h2 className="text-lg font-bold">Drop</h2>
          <div className="mt-4">
          {pickupLocation?.latitude && pickupLocation?.longitude && (
              <div>
                <button
                  className="flex items-center space-x-2 text-black"
                  onClick={() =>
                    window.open(`google.navigation:q=${pickupLocation.latitude},${pickupLocation.longitude}&mode=d`)
                  }
                >
                  <IconComponent
                    iconSet="MaterialCommunityIcons"
                    iconName="map-marker"
                    iconSize={20}
                    className="text-black"
                  />
                  <span className="text-sm">Open in Maps</span>
                </button>

                <div className="mt-2">
                  {pickupLocation.title && <p className="text-base font-medium">{pickupLocation.title}</p>}
                  {pickupLocation.subText && <p className="text-sm">{pickupLocation.subText}</p>}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoRoute;

